/**
 * Service Worker Registration
 * Call this from the root layout to register the SW.
 */

'use client';

export function registerServiceWorker(): void {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) {
    console.log('[SW] Service Workers not supported');
    return;
  }

  // Register immediately — don't wait for 'load' event
  // (useEffect runs after load, so the event has already fired)
  registerSW();
}

async function registerSW() {
  try {
    const registration = await navigator.serviceWorker.register('/sw.js', {
      scope: '/',
    });

    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      if (newWorker) {
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'activated') {
            console.log('[SW] New version activated');
          }
        });
      }
    });

    console.log('[SW] Registered successfully, scope:', registration.scope);
  } catch (error) {
    console.error('[SW] Registration failed:', error);
  }
}
